import { PlayBase } from '../typings/api';
import { Video as APIVideo } from '../typings/api/video';

class VideoDetails {
  private session_id?: number;
  private streams: { hls?: string; dash?: string };
  private custom_data: string;
  private play: PlayBase;
  private runtime?: number;
  private user_progress?: number;
  private credits_start?: number;

  id: number;
  subtitles: { label?: string; language?: string; url: string }[];

  get title(): string {
    return this.play.title;
  }

  get secondaryTitle(): string {
    return this.play.theatre?.name ?? '';
  }

  get hls(): string {
    return this.streams.hls;
  }

  get dash(): string {
    return this.streams.dash;
  }

  get videoDuration(): number {
    return this.runtime;
  }

  get watchDuration(): number {
    return this.user_progress;
  }

  get watchProgress(): number | null {
    if (!this.videoDuration) {
      return 0;
    }

    return ((this.watchDuration / this.videoDuration) * 100) / 100;
  }

  get isCurrentlyWatched(): boolean {
    return this.watchDuration > 60 && this.watchProgress < 0.98;
  }

  get customData(): string {
    return this.custom_data;
  }

  get sessionId(): number {
    return this.session_id;
  }

  get endCreditsTime(): number {
    return this.credits_start || 0;
  }

  static fromJSON(json: Partial<APIVideo>): VideoDetails {
    return Object.assign(new VideoDetails(), json);
  }
}

export default VideoDetails;
